import { useState, useRef, useEffect } from 'react';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";

// Estilos
import './SearchInput.css'
import {SEARCH_FILTRO} from '../../constants/colors';

/*
    Componente de boton flotante de lupa que funciona para filtrar por busqueda.
        Donde buscar es la función que llama para filtrar por lo ingresado por el usuario.
*/
function SearchInput({ filter, buscar, handleOnBlur = () => console.log("onBlur")}) {

    const [localValue, setLocalValue] = useState(filter || '');
    const debounceRef = useRef(null);

    // Sincronizar si el padre resetea el filtro
    useEffect(() => {
        if (filter === '' && localValue !== '') {
            setLocalValue('');
        }
    }, [filter]);

    const handleChange = (e) => {
        const value = e.target.value;
        setLocalValue(value);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            buscar(value);
        }, 300);
    };

    return (
        <div className={`search-container add-search ${localValue ? 'conValor' : ''}`}>
            <FontAwesomeIcon icon={faMagnifyingGlass} className='add-search-cont' style={{color: SEARCH_FILTRO }} />
            <input onBlur={handleOnBlur} placeholder='Buscar... puede encerrar entre comillas dobles para "coincidencia exacta"' className='input-search-txt' value={localValue} onChange={handleChange} />
        </div>
    );
}

export default SearchInput
